import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../../Redux/Action/Action";

const TravelPreferencesModal = ({ formData }) => {
  const dispatch = useDispatch();
  const { isOpen, modalData } = useSelector((state) => state);
  const place = useSelector(state => state.place);

  const [visibleCount, setVisibleCount] = useState(20); // show 20 initially

  useEffect(() => {
    if (isOpen) {
      setVisibleCount(20); // reset when modal opens
      document.body.classList.add("modal-open");

      if (modalData?.scriptSrc) {
        const container = document.getElementById("modal-script-container");
        if (container) {
          container.innerHTML = "";
          const script = document.createElement("script");
          script.src = modalData.scriptSrc;
          script.async = true;
          script.charset = "UTF-8";
          container.appendChild(script);
        }
      }
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpen, modalData]);

  if (!isOpen) return null;

  return (
    <>
      <div
        className="modal fade show"
        style={{ display: "block" }}
        tabIndex={-1}
        role="dialog"
        onClick={() => dispatch(closeModal())}
      >
        <div
          className="modal-dialog modal-xl modal-dialog-centered"
          role="document"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            {/* Header */}
            <div className="modal-header">
              <h5 className="modal-title">{modalData?.title}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => dispatch(closeModal())}
              ></button>
            </div>

            {/* Body */}
            <div className="modal-body">

              {/* ✅ Hotel deals */}
              {modalData?.scriptSrc && (
                <div id="modal-script-container"></div>
              )}

              {/* ✅ Flight deals with pagination */}
              {modalData?.images && Array.isArray(modalData.images) && (
                <>
                  <div className="row">
                    {modalData.images.slice(0, visibleCount).map((img, i) => (
                      <div className="col-lg-3 col-12" key={i}>
                        <a href={img?.link} target="_blank" rel="noreferrer">
                          <div data-aos="zoom-in-right" className="discount-blocks blog">
                            <img loading="lazy" src={img?.image} alt="Flight-deals" />
                            <h5>
                              {img?.city_name}{" "}
                              <i
                                className="fa fa-plane flight_deal_icon"
                                aria-hidden="true"
                              ></i>{" "}
                              {formData.destination || place || "chicago"}
                            </h5>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>

                  {/* Load More button */}
                  {visibleCount < modalData.images.length && (
                    <div className="text-center mt-3">
                      <button
                        className="btn btn-primary"
                        onClick={() => setVisibleCount((prev) => prev + 20)}
                      >
                        Load More
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Backdrop */}
      <div className="modal-backdrop fade show"></div>
    </>
  );
};

export default TravelPreferencesModal;
